import { forwardRef } from 'react';

import type { field } from 'components/HsForm/types';

const HiddenInput = forwardRef<HTMLInputElement, field>((props, ref) => <input ref={ref} {...props} type="hidden" />);

export default HiddenInput;
